import { ROUTES } from '@utils/routes.ts';

import cardImg1Com2 from '@assets/images/home/com2/main_banner_first.png';
import cardImg4Com2 from '@assets/images/home/com2/main_banner_fourth.png';
import cardImg2Com2 from '@assets/images/home/com2/main_banner_second.png';
import cardImg3Com2 from '@assets/images/home/com2/main_banner_third.png';
import cardImg5 from '@assets/images/home/main_banner_fifth.png';
import cardImg1 from '@assets/images/home/main_banner_first.png';
import cardImg4 from '@assets/images/home/main_banner_fourth.png';
import cardImg2 from '@assets/images/home/main_banner_second.png';
import cardImg6 from '@assets/images/home/main_banner_skinplace.png';
import cardImg3 from '@assets/images/home/main_banner_third.png';
import cardImg1Ngu3 from '@assets/images/home/ngu3/main_banner_first.png';
import cardImg4Ngu3 from '@assets/images/home/ngu3/main_banner_fourth.png';
import cardImg2Ngu3 from '@assets/images/home/ngu3/main_banner_second.png';
import cardImg3Ngu3 from '@assets/images/home/ngu3/main_banner_third.png';

import { config } from '@/config.ts';

const isNgu3 = config.BRAND === 'ngu3';
const isCom2 = config.BRAND === 'com2';

export const CardsListDefault = [
	{
		id: 'def_card_1',
		img: isNgu3 ? cardImg1Ngu3 : isCom2 ? cardImg1Com2 : cardImg1,
		text_key: 'quests',
		text: '',
		link: ROUTES.QUESTS,
		pmOnly: false
	},
	{
		id: 'def_card_2',
		img: isNgu3 ? cardImg2Ngu3 : isCom2 ? cardImg2Com2 : cardImg2,
		text_key: 'shop',
		text: '',
		link: ROUTES.SHOP,
		pmOnly: false
	},
	{
		id: 'def_card_3',
		img: isNgu3 ? cardImg3Ngu3 : isCom2 ? cardImg3Com2 : cardImg3,
		text_key: 'tournaments',
		text: '',
		link: ROUTES.TOURNAMENTS,
		pmOnly: true
	},
	{
		id: 'def_card_4',
		img: cardImg6,
		text_key: '',
		text: 'Скины на PM баллы',
		link: ROUTES.SKINPLACE,
		pmOnly: false
	},
	{
		id: 'def_card_5',
		img: isNgu3 ? cardImg4Ngu3 : isCom2 ? cardImg4Com2 : cardImg4,
		text_key: 'profile',
		text: 'Профиль',
		link: ROUTES.PROFILE,
		pmOnly: false
	},
	{
		id: 'def_card_6',
		img: cardImg5,
		text_key: '',
		text: 'Делай ставки <br /> с Parimatch',
		link: 'https://parimatch.kz/',
		pmOnly: false
	}
];
